import {Component} from '@angular/core';
import {MdbTableModule} from 'mdb-angular-ui-kit/table';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MdbScrollbarModule} from 'mdb-angular-ui-kit/scrollbar';
import {TranslateModule} from '@ngx-translate/core';
import {MdbCheckboxModule} from 'mdb-angular-ui-kit/checkbox';
import {TableComponent} from '../../../utils/table/table.component';
import {TableColumnModel} from '../../../../models/table-column.model';
import {CustomerModel} from '../../../../models/resources/customer.model';
import {CustomerService} from '../../../../services/resources/customer.service';
import {CustomNotificationService} from '../../../../services/utils/custom-notification.service';
import {HttpErrorsService} from '../../../../services/utils/http-errors.service';
import {AResourceTableComponent} from '../../../AResourceTableComponent';
import {FormGroupHelper} from '../../../../helpers/form-group-helper';
import {MdbFileUploadModule} from 'mdb-angular-file-upload';
import {castCompanyTypeEnum, CompanyType} from "../../../../enums/company-type";

@Component({
  selector: 'app-customers-table',
  imports: [
    MdbTableModule,
    ReactiveFormsModule,
    MdbScrollbarModule,
    TranslateModule,
    MdbCheckboxModule,
    MdbFileUploadModule,
    TableComponent
  ],
  template: `
    <app-table
      [columns]="tableColumns"
      [data]="models()"
      [filterFormGroup]="filterFormGroup"
      [loading]="customerService.loading()"
      (doFilterRequest)="customerService.getAll($event)"
      (urlParamsChange)="this.urlParams = $event"
      [hasActiveFilters]="customerService.apiResponse().filters != undefined"
      [pagination]="customerService.paginationMeta()"
      [deleteLoadingIds]="this.deleteLoadingIds()"
    ></app-table>
  `,
  standalone: true,
  styles: ``
})
export class CustomersTableComponent extends AResourceTableComponent<CustomerModel> {
  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,
    [
      'company',
      'companyType'
    ]
  );

  tableColumns: TableColumnModel[] = [
    {
      name: 'TYPE',
      selector: [{selector: 'companyType'}],
      filterFormControl: this.filterFormGroup.get('companyType'),
      filterFormControlLabel: 'TYPE',
      filterUrlParam: 'company-type',
      enum: CompanyType,
      enumCastFunction: castCompanyTypeEnum
    },
    {
      name: 'CUSTOMERS.COMPANY',
      selector: [{selector: 'company'}],
      filterFormControl: this.filterFormGroup.get('company'),
      filterFormControlLabel: 'CUSTOMERS.COMPANY',
      filterUrlParam: 'company'
    },
    {
      name: 'ADDRESS',
      selector: [
        {
          selector: 'address.street',
          suffix: ' ',
        },
        {
          selector: 'address.houseNumber',
          suffix: ' ',
        },
        {selector: 'address.addressSuffix', suffix: ', '},
        {selector: 'address.postcode', suffix: ' '},
        {
          selector: 'address.place'
        }
      ],
      // filterFormControl: this.filterFormGroup.get('address'),
      // filterFormControlLabel: 'ADDRESS',
      // filterUrlParam: 'address',
    },
    // {
    //   name: 'CUSTOMERS.REFERENCE',
    //   selector: [{selector: 'reference'}]
    // },
    // {
    //   name: 'CUSTOMERS.PERSON_NAME',
    //   selector: [
    //     { selector: 'person.name' }
    //   ],
    //   filterFormControl: this.filterFormGroup.get('name'),
    //   filterFormControlLabel: 'NAME',
    //   filterUrlParam: 'name'
    // },
    // {
    //   name: 'CUSTOMERS.USED',
    //   selector: [{selector: 'used'}],
    //   isCheckbox: true
    // },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          isObjectLink: true
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ];

  constructor(
    formBuilder: FormBuilder,
    public customerService: CustomerService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService
  ) {
    super(formBuilder, customerService, httpErrorsService, notificationService, 'CUSTOMERS');
  }
}
